import { FragmentType } from '@mp/graphql/generated';
import React from 'react';
import { JobDetailsFragment } from '../../jobDetailsComponents/graphql';
import { useShiftSwapData } from '../useShiftSwapData';
import { JobDetailsDeniedBanner } from './JobDetailsDeniedBanner';
import { JobDetailsAwaitReleaseBanner } from './JobDetailsAwaitReleaseBanner';

export const ShiftReleaseBanners = ({
  job,
}: {
  job?: FragmentType<typeof JobDetailsFragment> | null;
}) => {
  const {
    proHasSwapRequestPendingFacility,
    proDidSwapRequest,
    proAwaitingReleaseRequest,
    proAwaitingDropRequest,
    requestRejected,
    requestType,
    requestExpired,
    canShowShiftReleaseInfo,
    proAskedForReleaseButJobIsNotReassigned,
    expirationInfo,
    timezone,
    reasonMessage,
  } = useShiftSwapData({ job });

  if (!canShowShiftReleaseInfo) {
    return null;
  }

  if (requestRejected || requestExpired) {
    return (
      <JobDetailsDeniedBanner
        requestKind={requestType}
        isExpired={requestExpired}
        reasonMessage={reasonMessage}
      />
    );
  }

  const isAwaiting =
    proHasSwapRequestPendingFacility ||
    proDidSwapRequest ||
    proAwaitingDropRequest ||
    proAskedForReleaseButJobIsNotReassigned ||
    proAwaitingReleaseRequest;

  if (isAwaiting) {
    return (
      <JobDetailsAwaitReleaseBanner
        proDidSwapRequest={proDidSwapRequest}
        proHasSwapRequestPendingFacility={proHasSwapRequestPendingFacility}
        proAwaitingDropRequest={proAwaitingDropRequest}
        proAwaitingReleaseRequest={proAwaitingReleaseRequest}
        proAskedForReleaseButJobIsNotReassigned={proAskedForReleaseButJobIsNotReassigned}
        expirationInfo={expirationInfo}
        timezone={timezone}
      />
    );
  }

  return null;
};
